import { render, staticRenderFns } from "./nullDataSearch.vue?vue&type=template&id=bf9970b6&scoped=true&"
import script from "./nullDataSearch.vue?vue&type=script&lang=js&"
export * from "./nullDataSearch.vue?vue&type=script&lang=js&"
import style0 from "./nullDataSearch.vue?vue&type=style&index=0&id=bf9970b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9970b6",
  null
  
)

export default component.exports